import { CurrencyPipe, NgOptimizedImage } from "@angular/common";
import { Component, computed, input, model } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import { SvgIconComponent } from "angular-svg-icon";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../common/pipes/get-directus-image.pipe";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsAdPackagesBlock } from "../../../api/packbo/models/items-ad-packages-block";
import { SanitizeAdPackagePipe } from "./pipes/sanitize-supplier-package.pipe";

@Component({
    selector: "packbo-ad-packages-block",
    templateUrl: "./ad-packages-block.template.html",
    imports: [
        DirectusTranslationPipe,
        SvgIconComponent,
        CurrencyPipe,
        TranslocoPipe,
        SanitizeAdPackagePipe,
        NgOptimizedImage,
        GetDirectusImagePipe
    ]
})
export class AdPackagesBlockComponent {
    public readonly adPackagesBlock = input.required<ItemsAdPackagesBlock>();

    protected readonly isMobileView = model(false);

    protected readonly packagesFeaturesRefs = computed(() => this.adPackagesBlock().ad_packages_features_refs);
    protected readonly packagesFeatures = computed(() =>
        sanitizeDirectusRelationArray(this.packagesFeaturesRefs(), "package_features_id")
            .map((feature) => sanitizeDirectusObject(feature))
            .filter(isDefined)
    );
    protected readonly adPackagesRefs = computed(() => this.adPackagesBlock().ad_packages_refs);
    protected readonly adPackages = computed(() =>
        sanitizeDirectusRelationArray(this.adPackagesRefs(), "ad_packages_id")
            .map((adPackage) => sanitizeDirectusObject(adPackage))
            .filter(isDefined)
    );
    protected readonly currentImage = computed(() =>
        this.isMobileView() ? this.adPackagesBlock().mobile_image : this.adPackagesBlock().web_image
    );
    protected readonly buttons = computed(() => [
        {
            id: "web",
            icon: "assets/icons/Monitor.svg",
            translationKey: "ad_packages_block.web_preview",
            isActive: !this.isMobileView(),
            onClick: () => this.isMobileView.set(false)
        },
        {
            id: "mobile",
            icon: "assets/icons/Phone-Mobile-Device-Iphone-X-1.svg",
            translationKey: "ad_packages_block.mobile_preview",
            isActive: this.isMobileView(),
            onClick: () => this.isMobileView.set(true)
        }
    ]);
}
